import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import clsx from "clsx";

import type { CoretexTheme } from "../../theme";

const useStyles = makeStyles((theme: CoretexTheme) => ({
  root: {
    display: "flex",
    backgroundColor: theme.palette.mono.white,
    minHeight: 53,
    height: "100%",
    padding: 8,
  },
  icon: {
    flex: 0,
    maxWidth: "15%",
  },
  content: {
    flex: 1,
    minWidth: "65%",
    height: "100%",
  },
  miscellaneous: {
    flex: 1,
    marginLeft: "auto",
    minWidth: "20%",
    maxWidth: "20%",
  },
}));

export interface CardHeaderProps {
  content: React.ReactNode;
  className?: string;
  icon?: React.ReactNode;
  miscellaneous?: React.ReactNode;
  onClick?: () => void;
}

const CardHeader = ({ content, className, icon, miscellaneous, onClick }: CardHeaderProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Box className={clsx(classes.root, className)} onClick={onClick}>
      {icon && <Box className={classes.icon}>{icon}</Box>}
      <Box className={classes.content}>{content}</Box>
      {miscellaneous && <Box className={classes.miscellaneous}>{miscellaneous}</Box>}
    </Box>
  );
};

export default CardHeader;
